import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import StyledSliderItem from './SliderItem.style';

const videoStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '98%',
  height: '100%',
  border: '8px ridge #ddd',
};

const getVideoItem = (video) => (
  <>
    <h2 className="slider-item-title">
      {' '}
      {video.title}
      {' '}
    </h2>
    <StyledSliderItem>
      <iframe
        src={`https://player.vimeo.com/video/${video.id}?color=ff0179&title=0&byline=0&portrait=0`}
        style={videoStyle}
        frameBorder="0"
        allow="autoplay; fullscreen"
        allowFullScreen
        title={video.title}
      />
    </StyledSliderItem>
  </>
);


const VideoSlider = React.forwardRef(({ data, activeGridIndex, setActiveGridIndex }, ref) => {
  const [orderedData, setOrderedData] = useState([]);
  const sliderRef = React.useRef();

  useEffect(() => {
    const dataOrdered = [...data.slice(activeGridIndex), ...data.slice(0, activeGridIndex)];
    setOrderedData(dataOrdered);
  }, [data]);


  useEffect(() => {
    sliderRef.current.slickGoTo(activeGridIndex);
  }, [data, activeGridIndex]);

  const settings = {
    className: 'center',
    centerMode: true,
    infinite: true,
    centerPadding: '200px',
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
    lazyLoad: true,
    afterChange: (current) => setActiveGridIndex(current),
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          centerMode: false,
          swipeToSlide: true,
          className: '',
        },
      }],
  };

  return (
    <div ref={ref}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Slider {...settings} ref={sliderRef}>
        {orderedData.map((video) => (getVideoItem(video)))}
      </Slider>
    </div>
  );
});

export default VideoSlider;
